// extracted by mini-css-extract-plugin
module.exports = {"landingPicture":"Intro_landingPicture__JwghO","center":"Intro_center__37CWh","autoMargin":"Intro_autoMargin__-iO_D"};